import { createSlice } from '@reduxjs/toolkit';

import { objectToCamelCase } from '../../../../libs/format';
import { buildGenericAdapter } from '../../../../libs/slices';

const styleRuleConfigurationsAdapter = buildGenericAdapter();

const initialState = styleRuleConfigurationsAdapter.getInitialState();

const styleRuleConfigurationSlice = createSlice({
  name: 'styleRuleConfigurations',
  initialState,
  reducers: {
    updateStyleRuleConfiguration: (state, action) => {
      const { id, changes } = action.payload;
      const newChanges = objectToCamelCase(changes);
      styleRuleConfigurationsAdapter.updateOne(state, { id, changes: newChanges });
    },
    removeStyleRuleConfiguration: styleRuleConfigurationsAdapter.removeOne,
    setAllStyleRuleConfigurations: (state, action) => {
      const styleRuleConfigurations = objectToCamelCase(action.payload);
      styleRuleConfigurationsAdapter.setAll(state, styleRuleConfigurations);
    },
    addStyleRuleConfiguration: (state, action) => {
      const styleRuleConfiguration = objectToCamelCase(action.payload);
      styleRuleConfigurationsAdapter.addOne(state, styleRuleConfiguration);
    },
  },
});

export const {
  addStyleRuleConfiguration,
  setAllStyleRuleConfigurations,
  updateStyleRuleConfiguration,
  removeStyleRuleConfiguration,
} = styleRuleConfigurationSlice.actions;

export default styleRuleConfigurationSlice.reducer;

export const {
  selectAll: selectAllStyleRuleConfigurations,
  selectById: selectStyleRuleConfigurationById,
  selectIds: selectStyleRuleConfigurationIds,
} = styleRuleConfigurationsAdapter.getSelectors((state) => state.styleRuleConfigurations);
